import React from "react";
import QRCode from "qrcode.react";


const ComponentToPRint = React.forwardRef((props, ref) => {
  const { ComponentToPrint, HeaderToPrint,rowsData } = props;
  console.log(ComponentToPrint)
  return (
    <div ref={ref} style={{ margin: '10px' }}>
      <style type="text/css" media="print">
        {" @page {size : landscape}"}

      </style>
      {/* <ComponentToPrint/> */}
      <div>
        <div style={{ padding: "1rem", display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
          <img alt="seal" src={require('../../../assets/images/GuamSeal.svg').default} style={{ width: '150px', height: "100px", marginRight: "auto", marginLeft: "1rem" }} />

          <div style={{ marginRight: "2rem" }}>
            <QRCode
              id="qr-gen"
              value={`Employee Name = ${rowsData?.[0]?.Employee_Name}, Employee Number = ${rowsData?.[0]?.EmployeeId}, Department = ${rowsData?.[0]?.Dept_Code}, Division = ${rowsData?.[0]?.Division_Code}`}
              size={100}
              level={"H"}
              includeMargin={true}
            />
          </div>
        </div>
        <div style={{ margin: '18px auto', width: '100vw' }}>
          {HeaderToPrint}
        </div>
        {ComponentToPrint}
      </div>
    </div>
  );
});

export default ComponentToPRint;

